import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { UntilDestroy } from '@ngneat/until-destroy'
import { BehaviorSubject } from 'rxjs'
import { map, switchMap, take } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { ConfigOptionsKeys } from 'src/app/shared/constants'
import { ConfigurationOptionService } from '../configuration-option.service'
import { ConfigurationOptionMemberFormConfigTabBase } from '../member-form-config-tab.base'
import { configurationOptionSelectors } from '../configuration-option.selectors'

@UntilDestroy()
@Component({
  selector: 'configuration-option-revalidate-form-tab',
  templateUrl: './show.component.html',
  styleUrls: ['../registration-tab/show.component.scss']
})
export class ConfigurationOptionRevalidateFormTabComponent
  extends ConfigurationOptionMemberFormConfigTabBase
  implements OnInit
{
  public readonly revalidationVariants = [
    {
      key: ConfigOptionsKeys.MEMBER_REVALIDATION_FORM_CONFIG,
      labelTranslationKey: 'memberModule.revalidateFormRegular'
    },
    {
      key: ConfigOptionsKeys.MEMBER_REVALIDATION_SSO_FORM_CONFIG,
      labelTranslationKey: 'memberModule.revalidateFormSso'
    }
  ]
  public isRevalidationMode = true
  public activeFormConfigKey = ConfigOptionsKeys.MEMBER_REVALIDATION_FORM_CONFIG
  private readonly selectedFormConfigKey$ = new BehaviorSubject<string>(
    ConfigOptionsKeys.MEMBER_REVALIDATION_FORM_CONFIG
  )

  constructor(
    store: Store<AppState>,
    fb: UntypedFormBuilder,
    notificationService: NotificationService,
    actions$: Actions,
    configOptionService: ConfigurationOptionService
  ) {
    super(store, fb, notificationService, actions$, configOptionService)
  }

  ngOnInit() {
    this.initializeMemberFormConfigEditor(
      this.selectedFormConfigKey$.pipe(
        switchMap((configKey) =>
          this.store.select(configurationOptionSelectors.selectAll).pipe(
            map((configOptions) =>
              configOptions.find(
                (configOption) =>
                  configOption.key === configKey && configOption.siteId == null
              )
            )
          )
        )
      ),
      false
    )
  }

  public onRevalidationVariantChange(
    configKey:
      | ConfigOptionsKeys.MEMBER_REVALIDATION_FORM_CONFIG
      | ConfigOptionsKeys.MEMBER_REVALIDATION_SSO_FORM_CONFIG
  ) {
    if (this.activeFormConfigKey === configKey) {
      return
    }

    this.activeFormConfigKey = configKey
    this.selectedFormConfigKey$.next(configKey)
  }

  public onSubmitRegistration(form): void {
    this.configOption$.pipe(take(1)).subscribe((configOption) => {
      this.dispatchCreateOrUpdateConfigOption({
        configOption,
        key: this.activeFormConfigKey,
        value: this.buildSerializedConfigOptionValue(form.value),
        siteId: null
      })
    })

    this.notifyOnSuccessfulUpsert()
  }
}
